import {
  BumpResourceSheetInterface,
  BumpResourceSheetPaidBatchInterface,
} from '@vatos-pas/common';
import { CAN_EDIT_BUMPOUT_TIMESHEET_PAID } from 'providers/permissions';
import { InjectedFieldProps, PublicFieldProps } from 'react-admin';
import PaidStatusField, { hasPaidHistory } from 'components/PaidStatusField';
import { isJobPhaseBumpType } from '../utils';
import {
  BUMPOUT_MARK_AS_PAID_RESOURCE,
  markAsPaidWarnings,
} from '../selection';

/** The Bumpout row fields the Paid? column reads. */
export type BumpoutPaidStatusRow = Pick<
  BumpResourceSheetInterface,
  | 'id'
  | 'bumpResourceType'
  | 'repairType'
  | 'jobLot'
  | 'paid'
  | 'countPaidHistory'
>;

type PaidCheckboxProps = PublicFieldProps &
  InjectedFieldProps<BumpoutPaidStatusRow>;

/**
 * Bumpout Timesheet Paid? column. Job phase bump rows write their history to
 * job-phase-bump-paid, repair payment rows to repair-payment-paid.
 */
const PaidCheckboxField = ({ record }: PaidCheckboxProps) => {
  if (!record) return null;

  const isJobPhaseBump = isJobPhaseBumpType(record.bumpResourceType);
  const markAsPaidBody: BumpResourceSheetPaidBatchInterface = isJobPhaseBump
    ? { jobPhaseBumpIds: [record.id] }
    : { repairPaymentIds: [record.id] };

  return (
    <PaidStatusField
      id={record.id}
      paid={!!record.paid}
      hasHistory={hasPaidHistory(record.countPaidHistory)}
      historyResource={
        isJobPhaseBump ? '/job-phase-bump-paid' : '/repair-payment-paid'
      }
      foreignKeyName={isJobPhaseBump ? 'jobPhaseBumpId' : 'repairPaymentId'}
      editPermission={CAN_EDIT_BUMPOUT_TIMESHEET_PAID}
      title={`${record.repairType} - Lot # ${record.jobLot}`}
      bodyHeading="Payment Status History"
      unpaidLabel="Awaiting Payment"
      markAsPaid={{
        resource: BUMPOUT_MARK_AS_PAID_RESOURCE,
        warningsFor: markAsPaidWarnings,
        body: markAsPaidBody,
      }}
    />
  );
};

export default PaidCheckboxField;
